@for (cell of row.cells; track columnIndex; let columnIndex = $index) {
  <td
    [ngStyle]="columns[columnIndex].css"
    [class.clickable-cell]="isCellClickable(cell)"
    (click)="handleCellClick(cell)">
    @if (row.href && !isCellInteractive(cell)) {
      <a [routerLink]="row.href" class="row-link">
        <ng-container *ngTemplateOutlet="cellContent; context: {cell: cell}"></ng-container>
      </a>
    } @else {
      <ng-container *ngTemplateOutlet="cellContent; context: {cell: cell}"></ng-container>
    }
  </td>
}

<ng-template #cellContent let-cell="cell">
  @if (cell.copyable) {
    <i class="fa-regular fa-copy copy-icon"></i>
  }
  @if (cell.cellType === 'TextPill') {
    <motn-sort-table-cell-text-pill
      [cell]="$any(cell)"
    ></motn-sort-table-cell-text-pill>
  }

  @if (cell.cellType === 'DisplayName') {
    <motn-sort-display-name-cell
      [cell]="$any(cell)"
    ></motn-sort-display-name-cell>
  }

  @if (cell.cellType === 'TitleDescription') {
    <motn-sort-table-cell-title-description
      [cell]="$any(cell)"
    ></motn-sort-table-cell-title-description>
  }

  @if (cell.cellType === 'TitleSharingInfo') {
    <motn-sort-table-cell-title-sharing-info
      [cell]="$any(cell)"
    ></motn-sort-table-cell-title-sharing-info>
  }

  @if (cell.cellType === 'StatusDot') {
    <motn-sort-table-cell-status-dot
      [cell]="$any(cell)"
    ></motn-sort-table-cell-status-dot>
  }

  @if (cell.cellType === 'KebabMenu') {
    <motn-sort-table-cell-kebab-menu
      [cell]="$any(cell)"
      [row]="row"
    ></motn-sort-table-cell-kebab-menu>
  }

  @if (cell.cellType === 'Empty') {
    <motn-sort-table-cell-empty></motn-sort-table-cell-empty>
  }

  @if (cell.cellType === 'Icon') {
    <motn-sort-table-cell-icon
      [cell]="$any(cell)"
    ></motn-sort-table-cell-icon>
  }

  @if (cell.cellType === 'Buttons') {
    <motn-sort-table-cell-buttons
      [cell]="$any(cell)"
    ></motn-sort-table-cell-buttons>
  }

  @if (cell.cellType === 'UserLink') {
    <motn-sort-table-cell-user-link
      [cell]="$any(cell)"
    ></motn-sort-table-cell-user-link>
  }

  @if (cell.cellType === 'Toggle') {
    <motn-sort-table-cell-toggle
      [cell]="$any(cell)"
    ></motn-sort-table-cell-toggle>
  }

  @if (cell.cellType === 'RolePicker') {
    <motn-role-picker-cell
      [cell]="$any(cell)"
    ></motn-role-picker-cell>
  }

  @if (cell.cellType === 'Swatch') {
    <motn-sort-table-cell-swatch
      [color]="$any(cell).color"
    ></motn-sort-table-cell-swatch>
  }

  @if (cell.cellType === 'CurrentValue') {
    <motn-sort-table-cell-current-value
      [cell]="$any(cell)"
      [isVisible]="isVisible"
    ></motn-sort-table-cell-current-value>
  }

  @if (cell.cellType === 'Tags') {
    <motn-sort-table-cell-tags
      [cell]="$any(cell)"
    ></motn-sort-table-cell-tags>
  }
</ng-template>
